import { EventLocation } from "@types";
import useGetLocation from "./patstore/useGetLocation";

const useFindLocation = () => {
  const { locations } = useGetLocation();

  const findLocation: (T: EventLocation) => string | undefined = (
    location: EventLocation,
  ) => {
    if (!location) {
      return undefined;
    }
    if (location.type === "address") {
      if (location.address) {
        return location.address;
      } else return undefined;
    }

    if (location.type === "location") {
      if (location.location) {
        const locationObject = locations.find(
          (loc) => loc.objectId === location.location,
        );
        if (locationObject && locationObject.title) {
          return locationObject.title;
        } else return undefined;
      } else return undefined;
    }

    if (location.type === "online") {
      return "online";
    }

    if (location.type === "map") {
      return "Map";
    }
    return undefined;
  };

  return { findLocation };
};

export default useFindLocation;
